const PAYMENT_DISPLAY_TYPES = {
    NONE: 'none',
    PRICE_INCREASE_NO_REMAINING_INSTALLMENTS: 'pi_no_installments',
    PRICE_DECREASE_NO_REMAINING_INSTALLMENTS: 'pd_no_installments',
    PRICE_DECREASE_ANNUAL: 'pd_annual',
    PRICE_INCREASE_MORE_INSTALLMENTS_REMAINING: 'pi_more_installments_remaining',
    PRICE_DECREASE_MORE_INSTALLMENTS_REMAINING: 'pd_more_installments_remaining',
    PRICE_INCREASE_ONE_INSTALLMENT_REMAINING: 'pi_one_installment_remaining',
    PRICE_DECREASE_ONE_INSTALLMENT_REMAINING: 'pd_one_installment_remaining'
};

const PAGE_NAMES = {
    MANAGE_POLICY: 'manage-policy',
    CHANGE_POLICY: 'change-policy',
    VEHICLE_CHANGES: 'vehicle-changes',
    VEHICLE_CHANGES_REPLACE: 'vehicle-changes-replace',
    VEHICLE_CHANGES_REGISTRATION: 'vehicle-changes-registration',
    VEHICLE_CHANGES_EDIT: 'vehicle-changes-edit',
    DRIVER_CHANGES: 'driver-changes',
    DRIVER_CHANGES_ADD: 'driver-changes-add',
    DRIVER_CHANGES_REMOVE: 'driver-changes-remove',
    COVER_OPTIONS: 'cover-options',
    SUMMARY: 'summary',
    STATEMENTS: 'statements',
    RENEWAL_PROPOSAL: 'renewal-proposal',
    PAYMENTS: 'payments',
    DOCUMENTS: 'documents',
    HOW_TO_CLAIM: 'how-to-claim',
    MY_ACCOUNT: 'my-account',
    FAQ: 'faq',
    MTA_CONFIRMATION: 'confirmation',
    RENEWAL_CONFIRMATION: 'renewal-confirmation',
    UPDATE_PAYMENT_DETAILS: 'update-your-payment-details',
    CURRENT_PAYMENT_DETAILS: 'current-payment-details',
    NEW_PAYMENT_DETAILS: 'new-payment-details',
    RENEWAL_UPDATE_PAYMENT_DETAILS: 'renewal-update-your-payment-details',
    RENEWAL_CURRENT_PAYMENT_DETAILS: 'renewal-current-payment-details',
    RENEWAL_NEW_PAYMENT_DETAILS: 'renewal-new-payment-details',
    PAYMENT_PROCESS_END: 'payment',
    RENEWAL_PAYMENT_PROCESS_END: 'renewal-payment',
    ERROR_CONTACT_US: 'error-contact-us'
};

const PAID_STATUS = {
    FULLY_PAID: 'fullypaid',
    UNPAID: 'unpaid',
    BILLED: 'billed',
    PLANNED: 'planned',
    SCHEDULED: 'Scheduled',
    DUE: 'due',
    OVERDUE: 'Overdue',
    PAID: 'Paid'
};

const NO_POLICY_CHANGE_REASONS = {
    HOME_POLICY: 'no_change_on_home_policy',
    TRAVEL_POLICY: 'no_change_on_travel_policy',
    SMI_POLICY: 'no_change_on_smi_policy',
    FUTURE_RENEWALS: 'no_change_on_policy_with_future_renewals',
    SCHEDULED_POLICY: 'no_change_on_policy_with_scheduled_policy',
    FUTURE_BOUND_RENEWALS: 'no_change_on_policy_with_future_bound_renewals',
    MOTOR_HOME_POLICY: 'no_change_on_motor_home_policy',
    CASH_CHEQUE_PAYMENT_PLAN: 'no_change_on_cash_cheque_payment_plan',
    OUTSTANDING_PAYMENT: 'no_change_on_account_with_outstanding_payment',
    SPM_THIRD_PARTY_POLICY: 'no_change_on_spm_third_party_policy'
};

const RENEWED_POLICY_HEADER = 'Your renewed policy';

export default {
    CHANGE_EMAIL_LINK: 'https://www.saga.co.uk/my/account/edit-email-address',
    CHANGE_PASSWORD_LINK: 'https://www.saga.co.uk/my/account/reset-password',
    CHANGE_COMM_PREF_LINK: 'https://www.saga.co.uk/my/account/contact-preferences',
    CAR_POLICY_BOOK_LINK: 'https://www.saga.co.uk/insurance/car-insurance/policy-books',
    HOME_POLICY_BOOK_LINK: 'https://www.saga.co.uk/insurance/home-insurance/policy-documentation',
    LANDLORD_POLICY_BOOK_LINK: 'https://www.saga.co.uk/insurance/landlord-insurance/policy-documentation',
    HEALTH_POLICY_BOOK_LINK: 'https://www.saga.co.uk/insurance/health-insurance/policy-documents',
    TRAVEL_POLICY_BOOK_LINK: 'https://www.saga.co.uk/insurance/travel-insurance/policy-documents',
    CLAIM_PRE_AUTHORISE_LINK: 'https://www.axahealth.co.uk/saga-login',
    CLAIM_PMI_BUPA_LINK_REFER: 'https://www.bupa.co.uk/health/health-insurance/medical-referrals',
    CLAIM_PMI_BUPA_LINK_CLAIM: 'https://www.bupa.co.uk/help-and-support/making-a-claim',
    CLAIM_PMI_BUPA_LINK_APP: 'https://www.bupa.co.uk/touchdashboard',
    CLAIM_PMI_BUPA_CLAIM_FORM_URL: 'https://www.bupa.co.uk/~/media/Files/MMS/bins-13711',
    SAGA_GP_SERVICE_LINK: 'https://www.saga.co.uk/insurance/health-insurance/saga-gp-service',
    DELETE_COUNT: 1,
    PREFIX_TYPE: 'Online ',
    NEW_BUSINESS_ONE_STOP_DOCUMENT_TYPE: 'New Business One Stop',
    PAYMENT_DISPLAY_TYPES,
    PAGE_NAMES,
    PAID_STATUS,
    NO_POLICY_CHANGE_REASONS,
    RENEWED_POLICY_HEADER
};
